import React from "react";

const Policies = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 mt-16">
      <div className="bg-white shadow-lg rounded-lg w-5/6 max-w-6xl p-10">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-6">
          Terms & Policies
        </h1>
        <p className="text-gray-600 text-center mb-8">
          <strong>Effective Date:</strong> 08-02-2025 | <strong>Last Updated:</strong> 08-02-2025
        </p>

        {/* Terms & Conditions */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">1. Terms & Conditions</h4>
          <p className="text-gray-600">
            By using <strong>Himanshu Salary Corner</strong>, users agree to comply with all applicable rules and regulations set forth by the Maharashtra Government.  
            Users must provide <strong>accurate</strong> information to receive correct results. We are <strong>not responsible</strong> for any inaccuracies caused by user errors.  
            Unauthorized <strong>modification, duplication, or misuse</strong> of this website is strictly prohibited.  
          </p>
        </section>

        {/* Privacy Policy */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">2. Privacy Policy</h4>
          <p className="text-gray-600">
            We collect <strong>only essential</strong> user information for service processing and improvement.  
            The following details are stored:
          </p>
          <ul className="list-disc list-inside text-gray-600 mt-3 space-y-1">
            <li><strong>Name</strong></li>
            <li><strong>Email</strong></li>
            <li><strong>Phone Number</strong></li>
            <li><strong>Transaction Details</strong></li>
          </ul>
          <p className="text-gray-600 mt-3">
            We do <strong>not</strong> collect sensitive data. User information is stored securely and is <strong>not shared</strong> with third parties.  
            No account creation is required; users only need to submit the form as per their requirements.  
            If users request data retrieval, we can provide it <strong>within 7 days</strong> upon request.  
          </p>
        </section>

        {/* No Refund Policy */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">3. No Refund Policy</h4>
          <p className="text-gray-600">
            - Payments are <strong>final</strong>, and <strong>no refunds</strong> will be provided once a form is submitted.  
            - Users must verify the <strong>accuracy</strong> of their details before submission.  
            - If technical issues occur, users may <strong>contact support</strong> via email or phone for resolution.  
          </p>
        </section>

        {/* Shipping & Delivery */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">4. Shipping & Delivery</h4>
          <p className="text-gray-600">
            - Results are available <strong>instantly</strong> after payment through a <strong>downloadable PDF</strong> on the results page.  
            - If a valid email is provided, users <strong>may</strong> receive the result via email.  
            - If users enter an incorrect email or need to retrieve their results later, they can request them <strong>within 7 days</strong>.  
          </p>
        </section>

        {/* Data Accuracy & Validity */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">5. Data Accuracy & Validity</h4>
          <p className="text-gray-600">
            - If data is <strong>invalid</strong>, users will be notified via an <strong>alert box</strong> and will not be able to proceed with submission.  
            - If users enter <strong>incorrect</strong> data, it is <strong>not our responsibility</strong>, and no modifications will be made post-submission.  
          </p>
        </section>

        {/* Unauthorized Use & Restrictions */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">6. Unauthorized Use & Restrictions</h4>
          <ul className="list-disc list-inside text-gray-600 space-y-1">
            <li>Users are prohibited from using bots, scraping data, or attempting unauthorized access.</li>
            <li>Modifying, distributing, or disrupting website functionality is strictly forbidden.</li>
            <li>Violations may result in <strong>legal action and permanent restriction</strong>.</li>
          </ul>
        </section>

        {/* Contact Information */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">7. Contact & Support</h4>
          <p className="text-gray-600">
            For inquiries or technical support, please contact us:  
            📧 <strong>Email:</strong> <a href="mailto:admin@himanshusalarycorner.in" className="text-blue-500">admin@himanshusalarycorner.in</a>  
            📞 <strong>Phone:</strong> <a href="tel:+919403110160" className="text-blue-500">+91 9403110160</a>  
          </p>
        </section>

        {/* Amendments to Terms */}
        <section className="mb-8">
          <h4 className="text-2xl font-semibold text-gray-700 mb-3">8. Amendments to Terms</h4>
          <p className="text-gray-600">
            We reserve the right to <strong>update</strong> these policies at any time. Continued use of our services constitutes acceptance of the revised terms.  
          </p>
        </section>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-gray-600">&copy; {new Date().getFullYear()} Himanshu Salary Corner. All rights reserved.</p>
        </div>

        {/* Go Back Button */}
        <div className="text-center mt-6">
          <a href="/" className="text-blue-500 hover:underline text-lg">
            ← Go Back
          </a>
        </div>
      </div>
    </div>
  );
};

export default Policies;